import { render, staticRenderFns } from "./SettingWeight.vue?vue&type=template&id=0938fdae&scoped=true&"
import script from "./SettingWeight.vue?vue&type=script&lang=js&"
export * from "./SettingWeight.vue?vue&type=script&lang=js&"
import style0 from "./SettingWeight.vue?vue&type=style&index=0&id=0938fdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0938fdae",
  null
  
)

export default component.exports